'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _typeToReducer;

var _typeToReducer2 = require('type-to-reducer');

var _typeToReducer3 = _interopRequireDefault(_typeToReducer2);

var _types = require('shared/redux/middlewares/geocoding/types');

var _types2 = require('shared/modules/UpdateLocation/types');

var _types3 = require('shared/modules/Matcher/types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  hasMatched: false,
  location: {},
  interests: {},
  skills: [],
  education: null
};

var getSkills = function getSkills(currentSkills, id) {
  if (currentSkills.indexOf(id) === -1) {
    return currentSkills.concat(id);
  }

  return currentSkills.filter(function (skill) {
    return skill !== id;
  });
};

exports.default = (0, _typeToReducer3.default)((_typeToReducer = {}, (0, _defineProperty3.default)(_typeToReducer, _types3.CHANGE_INTEREST_VALUE, function (state, _ref) {
  var id = _ref.id,
      value = _ref.value;
  return (0, _extends4.default)({}, state, {
    hasMatched: true,
    interests: (0, _extends4.default)({}, state.interests, (0, _defineProperty3.default)({}, id, value))
  });
}), (0, _defineProperty3.default)(_typeToReducer, _types3.CHANGE_SKILL, function (state, _ref2) {
  var id = _ref2.id;
  return (0, _extends4.default)({}, state, {
    hasMatched: true,
    skills: getSkills(state.skills, id)
  });
}), (0, _defineProperty3.default)(_typeToReducer, _types3.CHANGE_EDUCATION, function (state, _ref3) {
  var id = _ref3.id;
  return (0, _extends4.default)({}, state, {
    hasMatched: true,
    education: id
  });
}), (0, _defineProperty3.default)(_typeToReducer, _types2.UPDATE_LOCATION, function (state, _ref4) {
  var location = _ref4.location;
  return (0, _extends4.default)({}, state, {
    location: (0, _extends4.default)({}, state.location, {
      address: location
    })
  });
}), (0, _defineProperty3.default)(_typeToReducer, _types.GEOCODE_LOCATIONS_FULFILLED, function (state, _ref5) {
  var locations = _ref5.locations;

  var matchingLocations = locations.filter(function (location) {
    return location.address === state.location.address;
  });

  if (matchingLocations.length > 0) {
    var _matchingLocations$sh = matchingLocations.shift(),
        location = _matchingLocations$sh.location;

    return (0, _extends4.default)({}, state, {
      location: (0, _extends4.default)({}, state.location, location)
    });
  }

  return state;
}), _typeToReducer), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/reducers/user/index.js
// module id = 1294
// module chunks = 0